.verticleAlignMiddle {
	vertical-align: middle;
}

.verticleAlignMiddleAndBold {
	vertical-align: middle;
	font-weight: bold;
}

.marginVerticalFourty {
	margin-top: 40px;
	margin-bottom: 40px;
}

.titleBackground {
	background-color: var(--title-background);
}
